import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Дашборд должен быть свежим, но не дёргать сервер слишком часто
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* basename="/admin" — SPA смонтирована на /admin/ (см. vite.config.ts base).
          Без basename все NavLink'и генерируют корневые URL ('/readiness'), и F5 даёт
          404 потому что worker не знает про '/readiness'. С basename все URL имеют
          вид '/admin/readiness' → SPA fallback в Program.cs его ловит и отдаёт index.html. */}
      <BrowserRouter basename="/admin">
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
